import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import CustomerOrders from '../components/customer-order/customer-order'
import dataLoad from '../actions/data-load';
import clearFilter from '../actions/clear-filter';

function mapStateToProps(state) {
  return {
    customerOrders: state.customerOrders.orders,
    fromDate: state.customerOrders.orderFilter.fromDate,
    toDate: state.customerOrders.orderFilter.toDate,
    typeValue: state.customerOrders.orderFilter.typeValue,
    ajaxStatuses: state.ajaxStatuses.dataLoad,
    balance: state.balance,
    user: state.user,
    customer: state.customer,
    payer: state.payerList.payerListing
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
    clearFilter
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrders);